import { render, staticRenderFns } from "./BasisForm.vue?vue&type=template&id=dda3ef2c&scoped=true"
import script from "./BasisForm.vue?vue&type=script&lang=js"
export * from "./BasisForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda3ef2c",
  null
  
)

export default component.exports